module.exports = __webpack_public_path__ + "knight.5fef4076.png";


//////////////////
// WEBPACK FOOTER
// ./demo/src/chess/knight.png
// module id = AxId
// module chunks = 0